module.exports = __webpack_public_path__ + "img/46.309450e9.png";